import { useEffect, useState } from "react";
import * as commonAPI from "../../../services/commonServices";
import { CustomNotification } from "../../../util/CustomNotification";
import { ModuleAndIdMapping, Modules } from "../../../constants/DatabaseConstants/MasterConstant";
import useGetOneMasterList from "../../../hooks/useGetOneMasterList";

type Props = {
  selectedCustomerId: number | null;
  selectedLocationId: number | null;
};

export const useCustomerLocationFilter = (props: Props) => {
  /* STATE */
  const [locationList, setLocationList] = useState<{ id: number; location_name: string }[] | null>(null);

  /* HOOK */
  const { masterList: customerMasterList } = useGetOneMasterList(ModuleAndIdMapping[Modules.CUSTOMER_MASTER]);

  /* EFFECT */
  useEffect(() => {
    const fetchLocationList = async (customerId: number) => {
      try {
        const response = await commonAPI.getLocationListByCustomerId(customerId);
        setLocationList(response?.data);
      } catch (error) {
        CustomNotification.showErrorMessage(error);
      }
    };
    if (props.selectedCustomerId) fetchLocationList(props.selectedCustomerId);
    else setLocationList([]);
  }, [props?.selectedCustomerId]);

  return { customerMasterList, locationList };
};
